import"./GlobalStyles.css.ts.vanilla.css";var l=function(){return null};export{l as default};
//# sourceMappingURL=GlobalStyles.js.map
